import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import { ArrowLeft, LockKeyhole } from 'lucide-react';

export default function AdminLogin() {
  const { login } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password.trim()) return;
    setError(''); setLoading(true);
    const res = await login(password);
    setLoading(false);
    if (!res.success) {
      setError(res.error || 'Invalid password');
      setPassword('');
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-box" onSubmit={handleSubmit}>
        <img src="/logo.png" alt="UDesign" className="login-logo" />
        <h1>Admin sign in</h1>
        <p className="login-sub">Status page control panel</p>
        <label className="login-label" htmlFor="admin-password">Password</label>
        <div className="login-input-wrap">
          <LockKeyhole size={16} aria-hidden="true" />
        <input
          id="admin-password"
          type="password"
          placeholder="Password"
          autoFocus
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        </div>
        <div className={`login-err ${error ? 'show' : ''}`} role="status" aria-live="polite">{error || ' '}</div>
        <button type="submit" className="sp-btn-primary" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
        <Link to="/" className="login-back"><ArrowLeft size={15} aria-hidden="true" />Back to status page</Link>
      </form>
    </div>
  );
}
